import React, { useEffect, useState, Fragment } from "react";
import * as Yup from "yup";
import yupSchema from "../../../../constants/schema";
import { useErrorHandler } from "../../../../hooks";
import DialogFormBuilder from "../../../../components/dialog-form-builder";
import PageBuilderRowService from "../../../../services/page-builder-row.service";

const initialValues = {
    title: "",
    showType: "",
};

const schema = Yup.object().shape({
    showType: yupSchema.type,
});

const defaultForm = [
    {
        _type: "textField",
        name: "title",
        label: "عنوان",
        autoFocus: true,
    },
    {
        _type: "autocomplete",
        _empty: undefined,
        name: "showType",
        options: [
            { value: "slider", title: "اسلایدر" },
            { value: "4cart", title: "4 کارت" },
            { value: "2cart", title: "2 کارت" },
            { value: "selectGlasses", title: "انتخاب عینک" },
            { value: "selectBrands", title: "انتخاب برند" },
        ],
        label: "نوع",
        disableClearable: true,
        valueSelector: "value",
        labelSelector: "title",
    },
];

export default function FormModalContent({ close, data, parent }) {
    const errorHandler = useErrorHandler();

    const handleSubmit = async (model, { setSubmitting }) => {
        model.pageId = parent.id;
        let op;
        if (data?.id) {
            op = await PageBuilderRowService.editPageBuilderRow(data.id, model);
        } else {
            op = await PageBuilderRowService.createPageBuilderRow(model);
        }
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };


    return (
        <DialogFormBuilder
            {...{
                close,
                name: "ردیف صفحه",
                data,
                schema,
                initialValues,
                handleSubmit,
                form: defaultForm,
            }}
        />
    );
}
